import { getProjectMember } from '@service/apis';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import commonActions from '@flux/action/common';
import { ErrorBackTo } from '@components/error';
import { getSessionStorage } from '@utils/windowUtil';

export const useProjectPermission = () => {
  const currentId = getSessionStorage('currentId');
  const { pathname } = useLocation();
  const userInfo = useSelector(({ login }) => login.userInfo);
  const permissionLoading = useSelector(
    (state) => state.projects?.permissionLoading,
  );
  const dispatch = useDispatch();
  const history = useHistory();

  const checkPermission = useCallback(
    async (projectId) => {
      if (!userInfo || !userInfo.uid) {
        return;
      }
      const projectMembersResp = await getProjectMember(projectId);

      if (!projectMembersResp) {
        return;
      }

      const { userList = [] } = projectMembersResp;

      const hasPermission =
        userInfo.isAdmin ||
        userInfo?.permissions?.includes('SystemAdmin.Gateway') ||
        userList.some(
          (e) =>
            String(e.userId).toLowerCase() ===
            String(userInfo.uid).toLowerCase(),
        );

      if (hasPermission) {
        return;
      }
      // dispatch(
      //   commonActions.showBanner({
      //     status: 'warning',
      //     content: 'Sorry. You don’t have the permission to open the page.',
      //     closeable: true,
      //   }),
      // );
      // setTimeout(() => {
      //   dispatch(commonActions.closeBanner());
      // }, 5000);
      // Pass projectId in URL so Error page can show "Go back to project home" and project admins.
      const errorUrl = `/error?backTo=${ErrorBackTo.projectDetail}&projectId=${projectId}`;
      window.SessionStorage.removeItem('currentId');
      window.SessionStorage.removeItem('projectName');
      history.replace(errorUrl);
    },
    [userInfo],
  );

  useEffect(() => {
    if (!currentId) {
      return;
    }
    // Never redirect to error while user is on a project-detail page — let PermissionCheck and
    // loaded permission data decide. This avoids redirecting before fetchPermissionData runs.
    const onProjectDetail = pathname && pathname.includes('project-detail');
    if (onProjectDetail) {
      return;
    }
    // Do not redirect to error while permission is still loading (e.g. fetchPermissionData in progress).
    if (permissionLoading) {
      return;
    }
    checkPermission(currentId);
  }, [currentId, permissionLoading, pathname]);
};
